import generateUniqueId from './generateUniqueId';

export default generateUniqueId;
